import React from 'react'

const StatisticsGraphTtoal = ({
  total = 0,
  value = 0,
  width = 200,
  color = 'lightgreen',
}) => {
  const height = 20

  let val = value === 0 || total === 0 ? 0 : (100 * value) / total
  val = val.toFixed(1)
  const wper = Math.round((val * width) / 100).toFixed(1)

  return (
    <svg
      viewBox={'0 0 ' + width + ' ' + height}
      style={{ backgroundColor1: 'yellow', border: '1px solid gray' }}
    >
      <rect
        key="total"
        width={width - wper}
        height={height}
        rx1={10}
        fill={color}
      />
      <rect
        key="totaol2"
        x={width - wper}
        width={wper}
        height={height}
        rx1={10}
        fill="lightblue"
      />
    </svg>
  )
}

export default StatisticsGraphTtoal
